import React from "react";
import EmptyStateDynamicFeild from "../../../../assets/empty-state-graphic.png";

export default function DynamicFieldInfo() {
  return (
    <div
      className="dynamicfieldinfo-wrapper animated fadeinright"
      data-test="dynamicfieldinfo-wrapper">
      <div
        className="dynamicfieldinfo-header"
        data-test="dynamicfieldinfo-header">
        Form fields in this template
      </div>
      <div className="dynamicfieldinfo-body" data-test="dynamicfieldinfo-body">
        <div className="content-scroll">
          <div
            className="dynamicfieldinfo-text addproduct-info"
            data-test="dynamicfieldinfo-body-text">
            Form fields are fillable placeholders. You can fill data in the
            fields when you create a document from this template.{" "}
            <a
              href="https://youtu.be/PNBR8CWdJbA?utm_source=revv%20app&utm_medium=create%20form%20field&utm_campaign=tutorial"
              rel="noopener noreferrer"
              target="_blank"
              data-test="dynamicfield-learn-more">
              Learn more
            </a>
          </div>
          <img
            data-test="dynamicfieldinfo-body-adddynamicfeild-img"
            className="adddynamicfeild-img"
            src={EmptyStateDynamicFeild}
            alt="integration-logo"
          />
          <div
            className="dynamicfieldinfo-note"
            data-test="dynamicfieldinfo-note">
            Looks like you have not added any form field in this document.
          </div>
          <div className="dynamicfieldinfo-panel">
            <div>
              <span role="img" aria-label="Hand" className="hand">
                👉
              </span>{" "}
              <strong>To add a form field,</strong>
            </div>
            <div className="dynamicfieldinfo-steps">
              1. Select and highlight text in template, eg. [Agreement date]
              <br />
              <br />
              2. Click{" "}
              <strong>
                <em>Add form field</em>
              </strong>{" "}
              in the top bar <br />
              <br />
              3. The Form Fields pane opens with a list of pre-defined fields.{" "}
              <br />
              <br />
              4. Search and select the relevant field, eg. Agreement date.{" "}
              <br />
              <br />
              5. Click{" "}
              <strong>
                <em>Save field</em>
              </strong>{" "}
              on the top. <br />
              <br />
              6. The text gets converted into the form field with a yellow
              highlight.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldInfo/DynamicFieldInfo.js